import {ActivityIndicator} from 'react-native';
import commonTranslator from '../../translator/common';
import {MyView, SimpleText} from '../CommonComponents.jsx';
import vars from '../root';
import {styles} from './styles';
import {useTheme} from 'styled-components';
export const Loader = props => {
  const theme = useTheme();
  return (
    <MyView
      style={{
        flex: 1,
        justifyContent: 'center',
        backgroundColor: vars.darkTransparent,
        color: vars.ORANGE_RED,
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        position: 'fixed',
        zIndex: 2,
      }}>
      <MyView>
        <ActivityIndicator color={vars.ORANGE_RED} size="large" />
        <SimpleText
          style={{
            color: theme.colors.text.base,
            ...styles.marginAuto,
            ...styles.bold,
            ...styles.fontSize20,
            ...styles.colorOrangeRed,
            ...styles.marginTop20,
          }}
          text={
            props.text
              ? props.text
              : commonTranslator.pleaseWait +
                ' ' +
                commonTranslator.processRunnig
          }
        />
      </MyView>
    </MyView>
  );
};
